import { render, staticRenderFns } from "./EmailDraftList.vue?vue&type=template&id=49d154a4"
import script from "./EmailDraftList.vue?vue&type=script&lang=js"
export * from "./EmailDraftList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports